// Main entry point for @sse/shared package
export * from './utils/index.js';
export * from './constants/index.js';
export * from './validators/index.js';
export * from './metadata/index.js';
export { normalizeMagnetConsent, normalizeConsentDestination, hasMagnetConsent, emptyMagnetConsent } from './metadata/magnetConsent.js';
